/**
 * Created by Kristy Kavvada on 26/2/2020.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('medReportPopup', {
                parent: 'customerMedReportsWithLines',
                url: '/add-med-report',
                data: {
                    authorities: ['ROLE_CHECKER']
                },
                templateUrl: 'app/displays/adminCustomers/medReports/medReportWithLines/medReportPopup/medReportPopup.html',
                controller: 'MedReportPopupController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
